import { Box, MenuItem, Select, Stack, Typography } from '@mui/material';
import React from 'react';

interface LineStyleDropdownProps {
  value: 'solid' | 'dashed' | 'dotted';
  onChange: (value: 'solid' | 'dashed' | 'dotted') => void;
}

export const LineStyleDropdown: React.FC<LineStyleDropdownProps> = ({
  value,
  onChange,
}) => {
  const styleLabel: Record<LineStyleDropdownProps['value'], string> = {
    solid: 'Continu',
    dashed: 'Tirete',
    dotted: 'Pointille',
  };

  const sampleSx: Record<LineStyleDropdownProps['value'], object> = {
    solid: { borderTopStyle: 'solid' },
    dashed: { borderTopStyle: 'dashed' },
    dotted: { borderTopStyle: 'dotted' },
  };

  const renderLineStyleOption = (
    lineStyle: LineStyleDropdownProps['value']
  ) => (
    <Stack direction="row" alignItems="center" spacing={1.25}>
      <Box
        sx={{
          width: 26,
          borderTopWidth: 2,
          borderTopColor: 'text.primary',
          ...sampleSx[lineStyle],
        }}
      />
      <Typography variant="body2">{styleLabel[lineStyle]}</Typography>
    </Stack>
  );

  return (
    <Select
      value={value}
      onChange={(e) =>
        onChange(e.target.value as 'solid' | 'dashed' | 'dotted')
      }
      size="small"
      fullWidth
      renderValue={(selected) =>
        renderLineStyleOption(selected as LineStyleDropdownProps['value'])
      }
    >
      <MenuItem value="solid">{renderLineStyleOption('solid')}</MenuItem>
      <MenuItem value="dashed">{renderLineStyleOption('dashed')}</MenuItem>
      <MenuItem value="dotted">{renderLineStyleOption('dotted')}</MenuItem>
    </Select>
  );
};
